import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { projectKey } from 'shared/constants'
import { usePoll } from 'shared/hooks/usePoll'

import { getGamesCategories } from 'features/slots/actions'

export const GamesCategoriesPolling: React.FC = () => {
  const dispatch = useDispatch()

  const handleGetGamesCategories = useCallback(async () => {
    dispatch(getGamesCategories(projectKey))
  }, [])

  usePoll(handleGetGamesCategories, { delay: 3 * 60 })

  return null
}

